<template>
    <div class="custom-checkbox">
        <input type="checkbox" :id="id" v-bind="$props" :checked="shouldBeChecked" :value="value" @change="updateInput" />
        <label :for="id">
            <div class="custom-checkbox-title">{{ label }}</div>
            <div class="custom-checkbox-subtitle">{{ subtitle }}</div>
        </label>
    </div>
</template>

<script>
export default {
    name: 'Checkbox',
    model: {
        prop: 'modelValue',
        event: 'change',
    },
    props: {
        value: {
            type: String,
        },
        modelValue: {
            default: false,
        },
        trueValue: {
            default: true,
        },
        falseValue: {
            default: false,
        },
        id: {
            type: String,
            required: false,
            default() {
                return 'checkbox_' + Math.random().toString(36).substring(2, 8) + Math.random().toString(36).substring(2, 8);
            }
        },
        label: {
            type: String,
            default() {
                return null
            }
        },
        subtitle: {
            type: String,
            default() {
                return null
            }
        },
    },
    computed: {
        shouldBeChecked() {
            if (this.modelValue instanceof Array) {
                return this.modelValue.includes(this.value)
            }
            return this.modelValue === this.trueValue
        }
    },
    methods: {
      updateInput(event) {
        let isChecked = event.target.checked

        if (this.modelValue instanceof Array) {
            let newValue = [...this.modelValue]
            
            if (isChecked) {
              newValue.push(this.value)
            } else {
              newValue.splice(newValue.indexOf(this.value), 1)
            }
            
            this.$emit('change', newValue)
        } else {
            this.$emit('change', isChecked ? this.trueValue : this.falseValue)
        }
      }
    },
};
</script>

<style lang="scss">
.custom-checkbox {
    /* Base for label styling */
    [type="checkbox"] {
        position: absolute;
        left: -9999px;
        
        & + label {
            position: relative;
            padding-left: 2.3em;
            cursor: pointer;
            
            &:before {
                content: '';
                position: absolute;
                left: 0; 
                top: 50%;
                transform: translateY(-50%);
                width: 25px; 
                height: 25px;
                border: 1px solid $darker-gray;
                background: $almost-black;
                border-radius: 4px;
            }
            
            &:after {
                content: url("../../assets/check-white.svg");
                width: 15px; 
                height: 15px;
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                left: 5px;
                font-size: 1.3em;
                line-height: 0.8;
                transition: all .3s;
            }
            
            .custom-checkbox-title {
                font-size: 15px;
            }
            .custom-checkbox-subtitle {
                font-size: 12px;
                font-weight: lighter;
                margin-top: -3px;
            }
        }
        
        &:not(:checked) {
            & + label:after {
                opacity: 0;
                transform: scale(0);
            }
        }
        
        &:checked {
            & + label:after {
                opacity: 1;
            }
        }
        
        // &:disabled {
        //     & + label {
        //         color: #aaa;
        //     }
            
        //     & + label:before {
        //         box-shadow: none;
        //         border-color: #bbb;
        //         background-color: #ddd;
        //     }
            
        //     &:checked + label:after {
        //         color: #999;
        //     }
        // }
        
        &:focus {
            & + label:before {
                border: 1px solid $darker-gray;
            }
        }
    }
    
    label:hover:before {
        border: 1px solid $dark-gray!important;
    }
}
</style>